import { searchHistoryConstants } from '../../constants';

export const clearSearchHistory = (key = searchHistoryConstants.OLD_KEY) => {
  localStorage.removeItem(key);
};
